/** The Cloud Run service hosting P0's service account connector. One per
 * identity project, so the name is fixed rather than derived: the project
 * already distinguishes it. */
export const CONNECTOR_SERVICE_NAME = "p0-connector-gcp-service-account";

/** The account id the connector runs as. Fixed for the same reason as the
 * service name, and inside the 30-character cap. */
export const CONNECTOR_SERVICE_ACCOUNT_ID = "p0-service-account-connector";

/** The connector's own role in the identity project, and the only authority
 * it holds.
 *
 * Derived from the call sequence rather than from an existing role minus
 * things, so that `iam.serviceAccounts.create`/`.delete` never lands in any
 * existing customer's IAM-writer role. Four exclusions, each deliberate:
 *   - `iam.serviceAccountKeys.*` — never. Tokens are minted by impersonation
 *     and this design holds no key material.
 *   - `.list` — the account id is always known before looking, so `get`
 *     suffices. Only an orphan sweeper would need it, and there is none.
 *   - `.update` — display name and description are set at create, never
 *     patched.
 *   - `.actAs` — the connector never impersonates the identity. The gateway
 *     does, and its authority is the binding on the account.
 */
export const CONNECTOR_CUSTOM_ROLE = {
  id: "p0AgenticIdentityManager",
  title: "P0 agentic identity manager",
  permissions: [
    "iam.serviceAccounts.create",
    "iam.serviceAccounts.delete",
    "iam.serviceAccounts.get",
    "iam.serviceAccounts.getIamPolicy",
    "iam.serviceAccounts.setIamPolicy",
    "resourcemanager.projects.get",
  ],
} as const;
